/* Publish by EComposer at 2026-10-06 11:52:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4j34qwq9qsb"]=  window.__ectimmers["ecom-4j34qwq9qsb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4j34qwq9qsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4j34qwq9qsb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3u2h8u266').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3u2h8u266', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtobgn2iwov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtobgn2iwov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y6reco91h4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6reco91h4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9eeavsx5mz4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9eeavsx5mz4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qu6hytich1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qu6hytich1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jv7rfmvhor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jv7rfmvhor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-js85p7ft8es').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-js85p7ft8es', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m00sofilk1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m00sofilk1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpni590xya9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpni590xya9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4j2nh6var07').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4j2nh6var07', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xh567z0xkkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xh567z0xkkj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7f57is2etc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7f57is2etc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8no5qt51y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8no5qt51y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3nmm02nq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3nmm02nq3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgp02nz1thb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgp02nz1thb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfr2yekv8qe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfr2yekv8qe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m74jvruuzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m74jvruuzk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18ja9yxk3oz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18ja9yxk3oz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-da64tx19ci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-da64tx19ci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0p23p6n9pc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0p23p6n9pc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxy4di1x4ah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxy4di1x4ah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i6bim76tto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i6bim76tto', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72cy40ay6jw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72cy40ay6jw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snz0nmlfv3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snz0nmlfv3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9sivmtylc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9sivmtylc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2asdjarjobx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2asdjarjobx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sc28jxsxk9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sc28jxsxk9d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wr9bybg7eie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wr9bybg7eie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r93bh25pv0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r93bh25pv0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mcpjdq8gs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mcpjdq8gs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idx6786cqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idx6786cqj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5eco59bvbwv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5eco59bvbwv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfuvclfz1ys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfuvclfz1ys', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nthluq5xze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nthluq5xze', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-467wgzbkx9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-467wgzbkx9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-veedh25vpd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-veedh25vpd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-efzuznikxw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-efzuznikxw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hdczm7jdveq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hdczm7jdveq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e57juaqc01e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e57juaqc01e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnwo2rzevsq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnwo2rzevsq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uohalhvsbyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uohalhvsbyn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o87cxo1ug6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o87cxo1ug6g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jax7f1qhjpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jax7f1qhjpf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6y82f16w3bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6y82f16w3bc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65jzh7axawy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65jzh7axawy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pebvvfm2qq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pebvvfm2qq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8j17bf0ab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8j17bf0ab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ha65rvgny6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ha65rvgny6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnbq6yehc5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnbq6yehc5p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10ddi1d0ix5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10ddi1d0ix5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wlrt8gkn38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wlrt8gkn38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkay7tiykg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkay7tiykg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-163j9vfpy08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-163j9vfpy08', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynrvb23zvnt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynrvb23zvnt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rnstjlfmwje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rnstjlfmwje', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wuz2kot3qqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wuz2kot3qqc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlc8f5s98gb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlc8f5s98gb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dhse6hqqiwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dhse6hqqiwq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9jdnyizxpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9jdnyizxpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-84g70whqyre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-84g70whqyre', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uoj8pafdt8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uoj8pafdt8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfqaixka8ka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfqaixka8ka', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amrs1xxvso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amrs1xxvso', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mczyk6fta8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mczyk6fta8s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pr1tfrng5r8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pr1tfrng5r8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rxvs44d8qj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rxvs44d8qj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qaqxw5kfxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qaqxw5kfxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9ame4wtow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9ame4wtow', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2lxxkg41f6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2lxxkg41f6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-smc6skiacwj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smc6skiacwj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5rascg7ujf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5rascg7ujf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-buhu6goam3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-buhu6goam3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p88c5dkafv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p88c5dkafv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lr5hviyhc1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lr5hviyhc1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tho8vm077b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tho8vm077b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ted5eqnzu1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ted5eqnzu1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1y7psy522aq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1y7psy522aq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xee83zh0nub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xee83zh0nub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unoo87l2tns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unoo87l2tns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4rkeh3c3c6v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4rkeh3c3c6v', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kuz7f3a01ms"]=  window.__ectimmers["ecom-kuz7f3a01ms"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-kuz7f3a01ms"]["5cmiwz4w1"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-kuz7f3a01ms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kuz7f3a01ms', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iaod4d0fbr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iaod4d0fbr8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ysfdybgrs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ysfdybgrs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijch60i1kw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijch60i1kw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tzil4buwzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tzil4buwzj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qjv6eh1x3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qjv6eh1x3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8opwj5f7x1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8opwj5f7x1o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72tbss64jbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72tbss64jbg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6cbfywgtig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6cbfywgtig', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8s5yia3yn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8s5yia3yn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fw27tqsqsg8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fw27tqsqsg8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51b3q3giva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51b3q3giva', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2y188lgs2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2y188lgs2j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hf1ylqebzvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hf1ylqebzvs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tk0grj30fv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tk0grj30fv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5unbr75gm0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5unbr75gm0i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g5leihw5o5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g5leihw5o5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1ojeqfwo26').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1ojeqfwo26', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8noxpyp4z9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8noxpyp4z9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn2bahvvdr6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn2bahvvdr6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0vp04f6u6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0vp04f6u6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvabnm9zfpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvabnm9zfpg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1by562avoc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1by562avoc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8s2rl7bz2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8s2rl7bz2j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddtsvzchy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddtsvzchy5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rss7k1araxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rss7k1araxm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20ms6jbutaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20ms6jbutaj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wk6n3gls8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wk6n3gls8s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ef42tlwppr6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ef42tlwppr6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w35zoc3vrhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w35zoc3vrhd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0knlcueleh5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0knlcueleh5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sslg9fcwzfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sslg9fcwzfe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yyrq7o6rd1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yyrq7o6rd1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-px5ymqcizqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-px5ymqcizqb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nzufsz4y7go').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nzufsz4y7go', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yj3y9s1exw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yj3y9s1exw', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wgaeaezez6o"]=  window.__ectimmers["ecom-wgaeaezez6o"] || {};
var C,L,A,I,j,E;let t=this.$el;if(!t)return;let e=this.isLive;const i=(C=this.settings.disable_auto_close)!=null?C:!1,o=(L=this.settings.disable_auto_close__tablet)!=null?L:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(E=this.settings.close_all)!=null?E:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(T){const R=T.getBoundingClientRect();return R.top>=0&&R.left>=0&&R.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&R.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(T){return n&&T<768||o&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const R=T.style.transition;T.style.transition="none",T.style.height="auto";const B=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=R,requestAnimationFrame(()=>{const q=r?"auto":e?B+"px":"auto";T.style.height=q})}function y(T){T.classList.remove("ecom-item-active");const R=T.querySelector(":scope > .ecom-accordion__body");R&&(r||(R.style.height=R.scrollHeight+"px",R.offsetHeight),requestAnimationFrame(()=>{R.style.height="0px"}))}function v(T){let R=0;if(T.offsetParent)do R+=T.offsetTop;while(T=T.offsetParent);return R}function w(T){const R=Math.max(0,T),B=window.pageYOffset||document.documentElement.scrollTop,q=R-B;if(q===0)return;const Z=300;let J=null;function W(oe){J||(J=oe);const se=Math.min((oe-J)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+q*Y),se<1&&window.requestAnimationFrame(W)}window.requestAnimationFrame(W)}function k(T){w(v(T)-100)}function $(T,R=!1){T.forEach((B,q)=>{const Z=B.parentNode,J=Z.querySelector(":scope > .ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion");const W=Z.classList.contains("ecom-item-active");J&&!a&&(R&&q===0||W)&&requestAnimationFrame(()=>{J.style.height=J.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,ue=Y.parentNode,ge=ue.querySelectorAll(":scope > .ecom-accordion__item"),de=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),V=f(se);if(U)V?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),de.forEach(fe=>fe.classList.remove("ecom-item-active")));else{V||(ge.forEach(y),de.forEach(Ee=>Ee.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ce=s||se>1024;function X(){window.dispatchEvent(new window.Event("renderScroll")),ce&&!m(K)&&k(K)}if(ce&&!r){let fe;const Ee=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{ue.removeEventListener("transitionend",Ee),X()},50))};ue.addEventListener("transitionend",Ee),setTimeout(()=>{ue.removeEventListener("transitionend",Ee),X()},600)}else requestAnimationFrame(()=>{setTimeout(X,100)})}})}$(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function z(){const T=window.location.hash;if(T){const R=t.querySelector(`[data-target="${T}"]`);if(R){R.click(),R.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=R.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>$(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-wgaeaezez6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wgaeaezez6o', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-paxcxq9efqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-paxcxq9efqc', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38uh59i7pwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38uh59i7pwa', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sa0ccrbef4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sa0ccrbef4n', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4b8rk90n28u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4b8rk90n28u', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2gb2fd2p68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2gb2fd2p68', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zldxcrsrvnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zldxcrsrvnn', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hzsh2zq7od').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hzsh2zq7od', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wvys84sv1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wvys84sv1o', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ah49iat2e1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ah49iat2e1a', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v1hpjlpj02').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v1hpjlpj02', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5z6fuup13e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5z6fuup13e', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n41hs5m7538').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n41hs5m7538', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s4zulfevm7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4zulfevm7b', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqtoym1tdbt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqtoym1tdbt', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0tqh1r2p1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0tqh1r2p1p', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-63s2wlc5uy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-63s2wlc5uy', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv076q95v2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv076q95v2q', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-muow3n6o7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-muow3n6o7p', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lx86k7p5jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lx86k7p5jp', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pk25viedmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pk25viedmc', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-scmm3nnqkt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-scmm3nnqkt9', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q69k2bnt7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q69k2bnt7', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zv0t6jqjytc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zv0t6jqjytc', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hky7ehhsaf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hky7ehhsaf', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jqckhp0u3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jqckhp0u3p', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06p5vsizra7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06p5vsizra7', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0p9pxkgdgl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0p9pxkgdgl', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zqoz4p9gdkb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqoz4p9gdkb', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qdkz7grp3b"]=  window.__ectimmers["ecom-qdkz7grp3b"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-qdkz7grp3b"]["aqg98gf2z"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-qdkz7grp3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qdkz7grp3b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulij1zx9nps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulij1zx9nps', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vwb5nsaqmr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vwb5nsaqmr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-olpekfmyy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-olpekfmyy8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vvid7n5gff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vvid7n5gff', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}